/* Mischief Mates cart helpers: one-click add-ons, and the pre-checkout pop-up.
   Everything fails open: any error, timeout or empty result goes straight to checkout. */
(function () {
  function drawer() { return document.querySelector('cart-drawer'); }
  function add(id, btn) {
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    var d = drawer();
    var body = { items: [{ id: +id, quantity: 1 }] };
    if (d) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (res) {
        if (btn) { btn.textContent = 'Added'; btn.classList.add('is-added'); }
        if (d && res.sections && !btn?.closest('.mm-pre-dialog')) { d.renderContents(res); }
        else if (d && res.sections) { refreshBehind(res); }
        else if (location.pathname.indexOf('/cart') === 0) { location.reload(); }
        else { fetch('/cart.js').then(function (c) { return c.json(); }).then(function (c) { var b = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]'); if (b) b.textContent = c.item_count; }); }
        return res;
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = 'Try again'; } });
  }
  function refreshBehind(res) {
    var d = drawer(); if (!d) return;
    ['cart-drawer', 'cart-icon-bubble'].forEach(function (id) {
      var html = res.sections[id]; if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var target = id === 'cart-drawer' ? document.querySelector('#CartDrawer') : document.getElementById(id);
      var src = id === 'cart-drawer' ? doc.querySelector('#CartDrawer') : doc.querySelector('.shopify-section');
      if (target && src) target.innerHTML = src.innerHTML;
    });
  }
  window.mmAddToCart = add;

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mm-add]');
    if (b) { e.preventDefault(); add(b.getAttribute('data-mm-add'), b); }
  });

  /* Pre-checkout pop-up, once per visit */
  var dlg;
  function goCheckout() { location.href = '/checkout'; }
  function openPre(html) {
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.className = 'mm-pre-dialog';
      dlg.setAttribute('aria-label', 'Before you check out');
      document.body.appendChild(dlg);
      dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-mm-pre-close]')) dlg.close(); });
    }
    dlg.innerHTML = '<button type="button" class="mm-pre-dialog__x" data-mm-pre-close aria-label="Close">&times;</button>' + html;
    var d = drawer(); if (d && d.classList.contains('active')) d.close();
    dlg.showModal();
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('#CartDrawer-Checkout, #checkout');
    if (!c || c.disabled) return;
    try { if (sessionStorage.getItem('mm-pre-seen')) return; } catch (err) { return; }
    e.preventDefault();
    var done = false;
    var timer = setTimeout(function () { if (!done) { done = true; goCheckout(); } }, 2500);
    fetch('/?sections=mm-precheckout', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (s) {
        if (done) return; done = true; clearTimeout(timer);
        var html = s['mm-precheckout'] || '';
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var pre = doc.querySelector('[data-mm-pre-ready]');
        if (!pre || !pre.querySelector('[data-mm-addon]')) { goCheckout(); return; }
        try { sessionStorage.setItem('mm-pre-seen', '1'); } catch (err) {}
        openPre(pre.outerHTML);
      })
      .catch(function () { if (!done) { done = true; clearTimeout(timer); goCheckout(); } });
  }, true);
  /* First-order sign-up pop-up: once per visitor, after 18s or desktop exit intent; thanks + code after posting */
  (function () {
    var tpl = document.getElementById('mm-signup-pop'); if (!tpl) return;
    var posted = /customer_posted=true/.test(location.search) || /form_type=customer/.test(location.search);
    function seen() { try { return localStorage.getItem('mm-sp') ; } catch (e) { return '1'; } }
    function mark(v) { try { localStorage.setItem('mm-sp', v || '1'); } catch (e) {} }
    function show(thanks) {
      if (document.querySelector('dialog[open]')) return;
      if (!thanks) mark();
      var d = document.createElement('dialog'); d.className = 'mm-pre-dialog'; d.setAttribute('aria-label', 'Get 15% off your first order');
      d.innerHTML = '<button type="button" class="mm-pre-dialog__x" data-mm-pre-close aria-label="Close">&times;</button>' + tpl.innerHTML;
      if (thanks) d.querySelector('.mm-sp').innerHTML = '<p class="mm-eyebrow">You\'re on the list</p><h2 class="mm-pre__title">Here\'s your 15%.</h2><p class="mm-sp__code">MISCHIEF15</p><p class="mm-sp__small">Use it at checkout on your first order.</p><button type="button" class="mm-btn mm-btn--solid" data-mm-pre-close>Start shopping</button>';
      d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-mm-pre-close]')) d.close(); });
      d.addEventListener('close', function () { d.remove(); });
      var f = d.querySelector('form'); if (f) f.addEventListener('submit', function () { mark('joined'); });
      document.body.appendChild(d); d.showModal(); window.mmPopupOpen = true;
    }
    /* Footer "Email" link (client 2026-10-05: it went to /#join and looked dead): opens this sign-up on any page. */
    document.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('[data-mm-signup]'); if (!a) return; e.preventDefault(); show(false); });
    if (posted && seen() === 'joined') { show(true); mark('done'); return; }
    if (seen() || /^\/(cart|checkout|account|challenge)/.test(location.pathname)) return;
    var t = setTimeout(function () { show(false); }, 18000);
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 8 && window.innerWidth > 900 && !seen()) { clearTimeout(t); show(false); } });
  })();
})();
